export default __webpack_public_path__ + "static/media/undraw_Wireframing_re_q6k6 1.c28bf73f.svg";